import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import PricesWidget from './prices-widget';
import {
  setPricesState,
  setActivePriceCarouselIdx,
  setActivePricesCarousel,
} from 'store/state/insightsContext/actions';
import { Route } from 'config/routes';
import { activePriceCarouselIdxSelector } from 'store/state/insightsContext/selectors';
import {
  PricesState,
  PricesAccordionSection,
  accordionDataSelector,
  pricesListingsSelector,
  pricesStateSelector,
  pricesItemsCountSelector,
} from 'store/state/selectors/insights/prices';
import {
  insightsLoadingSelector,
  resolvedLocalPageSelector,
} from 'store/state/domainData/selectors';
import { marketplaceSelector, routeSelector } from 'store/state/selectors/router';
import { flow } from 'lodash';
import { InsightType, MarketplaceType } from 'utils/entities';
import { IInsightPreview } from 'components/widget/common/styled';
import { makeCarouselDataSelectorByType } from 'store/state/selectors/utils';
import {
  isCollapsedInsightsSelector,
  showInsightsCarouselSelector,
} from 'store/state/selectors/insights/insightSections';

interface PricesProps {
  onSetPricesState: (nextState: Partial<PricesState>) => void;
  pricesState: PricesState;
  accordionData: PricesAccordionSection[];
  onReadMoreCarouselClick: (insightId: string) => void;
  isLoading: boolean;
  isUnit?: boolean;
  carouselData: IInsightPreview[];
  setActiveCarouselIdx: (index: number) => void;
  carouselIdx: number;
  pricesItemsCount: number;
  showPricesTable: boolean;
  zoneName?: string;
  projectId?: string;
  projectIds?: string[];
  marketplace?: MarketplaceType;
  isCollapsed?: boolean;
  showCarousel?: boolean;
}

export const isUnitSelector = flow(routeSelector, ({ name }) => name === Route.UnitPage);

const PriceCarouselDataSelectorByType = makeCarouselDataSelectorByType(InsightType.Prices);
export const showPricesTableSelector = flow(pricesListingsSelector, s => Boolean(s && s.tabs && s.tabs.length));
const zoneNameSelector = flow(resolvedLocalPageSelector, l => l ? l.zoneName : null);

const mapStateToProps = (state: State) => ({
  pricesState: pricesStateSelector(state),
  accordionData: accordionDataSelector(state),
  isLoading: insightsLoadingSelector(state),
  isUnit: isUnitSelector(state),
  carouselData: PriceCarouselDataSelectorByType(state),
  carouselIdx: activePriceCarouselIdxSelector(state),
  pricesItemsCount: pricesItemsCountSelector(state),
  showPricesTable: showPricesTableSelector(state),
  zoneName: zoneNameSelector(state),
  marketplace: marketplaceSelector(state),
  isCollapsed: isCollapsedInsightsSelector(state),
  showCarousel: showInsightsCarouselSelector(state),
});

const mapDispatchToProps = {
  onReadMoreCarouselClick: setActivePricesCarousel,
  onSetPricesState: setPricesState,
  setActiveCarouselIdx: setActivePriceCarouselIdx,
};

const Prices: React.FC<PricesProps> = ({
  isUnit,
  onSetPricesState,
  pricesState,
  accordionData,
  isLoading,
  carouselData,
  setActiveCarouselIdx,
  carouselIdx,
  onReadMoreCarouselClick,
  pricesItemsCount,
  showPricesTable,
  zoneName,
  projectId,
  projectIds,
  marketplace,
  isCollapsed,
  showCarousel,
}) => {
  if (isLoading) return null;

  const onlyAnalystInsight = marketplace === MarketplaceType.Commercial;

  return (
    <PricesWidget
      onSetPricesState={onSetPricesState}
      data={accordionData}
      activeSection={pricesState.accordion}
      tab={pricesState.tab}
      isArea={!isUnit}
      carouselData={carouselData}
      setActiveCarouselIdx={setActiveCarouselIdx}
      carouselIdx={carouselIdx}
      setActiveInsightId={onReadMoreCarouselClick}
      pricesItemsCount={pricesItemsCount}
      showTable={showPricesTable}
      zoneName={zoneName}
      projectId={projectId}
      projectIds={projectIds}
      onlyAnalystInsight={onlyAnalystInsight}
      isCollapsed={isCollapsed}
      showCarousel={showCarousel}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Prices);
